// @flow
import React from 'react';
import type {Node} from 'react';
import {AutocompleteSearch} from '@wellstone-solutions/web';
import {useStores} from 'hooks/useStores';
import {RoleChipOption} from './RoleChipOption';

type OptionType = {
  id: string,
  name: string,
  role?: string,
  user?: {id: string, email?: string},
};
type ValueType = OptionType | null;
type PropsType = {
  label: string,
  value: ValueType,
  roles: Array<string>,
  onOptionSelect: (newValue: ValueType) => void,
  excludeUserIds?: Array<string>,
  showRoleChips?: boolean,
  testId?: string,
};

export const DirectorySearch = ({
  label,
  value,
  roles,
  onOptionSelect,
  excludeUserIds = [],
  showRoleChips = false,
  testId = 'directory-search',
}: PropsType): Node => {
  const {organizationStore} = useStores();

  const handleSearch = async (searchTerm) => {
    const response = await organizationStore.search({
      searchTerm,
      queryBy: ['members'],
      statusFilters: ['active'],
    });

    if (response.isSuccess && response.data.members) {
      return response.data.members
        .filter(({role}) => roles.includes(role))
        .filter(({user}) => !user || !excludeUserIds.includes(user.id))
        .map(({id, name, role, user}) => ({
          id,
          name,
          role,
          user,
        }));
    } else {
      return [];
    }
  };

  return (
    <AutocompleteSearch
      label={label}
      value={value}
      optionLabelKey="name"
      optionValueKey="id"
      onOptionSelect={onOptionSelect}
      onSearch={handleSearch}
      renderOption={showRoleChips ? RoleChipOption : undefined}
      testId={testId}
    />
  );
};
